import type { FunctionComponent } from 'react';
import { useCallback, useMemo } from 'react';
import { Button } from '@george-labs.com/design-system';

import { copyText } from '@luna/utils';

import { DevToolsButton } from '../DevToolsButton';
import { buildAlexProxySessionLink } from './SessionLinkCopyButtonService';

export const SessionLinkCopyButton: FunctionComponent = () => {
    const sessionLink = useMemo(buildAlexProxySessionLink, []);

    const copyLinkToClipboard = useCallback(() => copyText(sessionLink), [sessionLink]);

    return (
        <DevToolsButton icon={Button.ICON.COPY} onClick={copyLinkToClipboard}>
            Copy session link
        </DevToolsButton>
    );
};
